var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Locations',{on:{"locationsLoaded":_vm.onLocationsLoaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }